export enum ConfigurationType {
    Trial = 1,
    TrialEvent = 2,
    Form = 3,
    Event = 4
}